import React from 'react'
import { Form, Row, Col, Button, Input } from 'antd'
import { Store } from 'antd/es/form/interface'

const SendMessage: React.FC<ISendMessageProps> = (props) => {

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  }

  const sendCode = (values: Store) => {
    const data = {
      jobNumber: values.jobNumber,
      vercode: values.vercode,
      uuid: props.verifyCode.uuid || ''
    }
    props.send(data)
  }

  return (
    <div>
      <Form {...formItemLayout} onFinish={sendCode}>
        <Form.Item label="请输入工号" name="jobNumber" className="form-item" rules={[{ required: true, message: '请输入工号' }]}>
          <Input placeholder="请输入工号" />
        </Form.Item>
        <Form.Item label="请输入验证码" name="vercode" className="form-item" rules={[{ required: true, message: '请输入验证码' }]}>
          <Row gutter={8}>
            <Col span={14}>
              <Input placeholder="请输入验证码" />
            </Col>
            <Col span={10} className="img-code" onClick={props.changeImg}>
              <img alt="验证码" src={(props.verifyCode && props.verifyCode.srcBase64) || null} />
            </Col>
          </Row>
        </Form.Item>
        <div className="btn">
          <Button className="btn-style" type="primary" htmlType="submit">发送验证码到手机</Button>
        </div>
      </Form>
    </div>
  )
}

interface ISendMessageProps {
  verifyCode: any
  changeImg: any
  send: any
}

export default SendMessage
